import { render, staticRenderFns } from "./LoginAndOrdersDashboard.vue?vue&type=template&id=690a88c8&scoped=true&"
import script from "./LoginAndOrdersDashboard.vue?vue&type=script&lang=js&"
export * from "./LoginAndOrdersDashboard.vue?vue&type=script&lang=js&"
import style0 from "./LoginAndOrdersDashboard.vue?vue&type=style&index=0&id=690a88c8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "690a88c8",
  null
  
)

export default component.exports